module.exports = __webpack_public_path__ + "assets/img/factory.0f5399ff.jpg";